import type { SetPasswordResult } from '../domain/types'
import type { SetPasswordAPIResponse } from './types'
import { SET_PASSWORD_API_STATUSES } from './types'

export function mapSetPasswordResult(response: SetPasswordAPIResponse | undefined): SetPasswordResult {
  return response?.status === SET_PASSWORD_API_STATUSES.PASSWORD_SET_AND_SIGNED_IN ? 'signedIn' : 'signInFailed'
}
